import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_GENERIC_DATA':
      return action.genericData
    default:
      return state
  }
}

export default reducer
